import {
  CodeProps as MantineCodeProps,
  Code as MantineCode,
} from '@mantine/core';

export type CodeProps = MantineCodeProps;

export const Code = MantineCode;

Code.displayName = 'Code';
